export default {
  CODE: 'CODE',
  EMOJI: 'EMOJI',
  EMOTICON: 'EMOTICON',
  EOF: 'EOF',
  MENTION: 'MENTION',
  NEWLINE: 'NEWLINE',
  ORDERED_ITEM: 'ORDERED_ITEM',
  ORDERED_LIST: 'ORDERED_LIST',
  SHORTCODE: 'SHORTCODE',
  SHRUG: 'SHRUG',
  SLASH_SHRUG: 'SLASH_SHRUG',
  TEXT: 'TEXT',
  UNORDERED_ITEM: 'UNORDERED_ITEM',
  UNORDERED_LIST: 'UNORDERED_LIST',
  URL: 'URL',
};
